import { Input } from 'components/input';
import React from 'react';
import RMSvgIcon from '../customComponents/CommonComponents/RMSvgIcon';
import { ButtonsListContainer } from 'components/Button';
import { IPagination } from './constans';
import './styles.scss';
import RMCustomButton from 'components/customComponents/CommonComponents/RMCustomButton/RMCustomButton';

interface Props {
  pagination: IPagination;
  onPageNumberChange: (pageNumber: number) => void;
  onPageSizeChange?: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  showRowsPerPage?: boolean;
  showSimplifiedVersion?: boolean;
  containerStyle?: string;
  customView?: React.ReactNode;
}
const Paginator = (props: Props) => {
  const {
    pagination,
    onPageNumberChange,
    onPageSizeChange,
    showRowsPerPage = true,
    showSimplifiedVersion = false,
    containerStyle = 'h-full bg-gray-200 flex flex-row-reverse align-center px-3',
    customView,
  } = props;

  const handlePreviousPage = () => {
    onPageNumberChange(pagination.page - 1);
  };

  const handleNextPage = () => {
    onPageNumberChange(pagination.page + 1);
  };

  const renderCurrentState = () => {
    return (
      <div
        id={`pagination-currentstate-${pagination.page}`}
        className="basis-1/12 flex justify-center"
      >
        {pagination.page}
        &nbsp;of&nbsp;
        {pagination.total >= 0 ? (
          Math.ceil(pagination.total / pagination.perPage)
        ) : (
          <div id={`pagination-currentstate-load`} className="loading-dots">
            ...
          </div>
        )}
      </div>
    );
  };

  const navigationButton = [
    {
      Icon: (
        <RMSvgIcon id="pagination-navigation-prev-icon" name="ArrowLeft" fill="#313131" />
      ),
      onClick: handlePreviousPage,
      isDisabled: pagination.page === 1,
    },
    {
      Icon: (
        <RMSvgIcon
          id="pagination-navigation-next-icon"
          name="ArrowRight"
          fill="#313131"
        />
      ),
      onClick: handleNextPage,
      isDisabled:
        pagination.total >= 0 && pagination.page >= pagination.total / pagination.perPage,
    },
  ];
  const renderButtons = () => {
    return (
      <>
        {!showSimplifiedVersion ? (
          <ButtonsListContainer buttonsList={navigationButton} />
        ) : (
          <>
            <RMCustomButton {...navigationButton[0]} />
            {renderCurrentState()}
            <RMCustomButton {...navigationButton[1]} />
          </>
        )}
      </>
    );
  };

  return (
    <div id="pagination-wrapper" className={containerStyle}>
      <div id="pagination-buttons-container" className="basis-1/12 flex justify-center">
        {renderButtons()}
      </div>
      {!showSimplifiedVersion && renderCurrentState()}
      {showRowsPerPage && (
        <>
          <div id="pagination-rowsperpage-input-wrapper" className="basis-1/12">
            <Input
              containerStyle={{ height: '2rem' }}
              inputStyle={{ height: '100%' }}
              inputType="select"
              name="rowsPerPage"
              id="pagination-input-rowsPerPage"
              options={[
                { title: '100', value: 100 },
                { title: '500', value: 500 },
                { title: '1000', value: 1000 },
                { title: '1500', value: 1500 },
              ]}
              value={pagination.perPage}
              onChange={onPageSizeChange}
            />
          </div>
          <label id="pagination-rowsperpage-label" className="basis-[10%] m-0 p-1 font-roboto" htmlFor="rowsPerPage">
            Items per page:
          </label>
        </>
      )}
      {customView}
    </div>
  );
};

export default Paginator;
